export type EnumType = { [key: string]: string }

export enum ApiKey {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgotPassword',
  Me = 'me',
  Message = 'message',
  Public = 'public',
  CountryList = 'countryList',
  CitiesList = 'citiesList',
  Manufactures = 'manufactures',
  Marketplace = 'marketplace',
  Categories = 'categories',
  SubCategories = 'subCategories',
  Sections = 'sections',
  Fields = 'fields',
  Types = 'types',
  Connections = 'connections',
  ConnectionList = 'connectionListing',
  NetworkList = 'networkListing',
  TypeList = 'typeListing',
  Models = 'models',
  List = 'list',
  Item = 'item',
  ListingDetails = 'list',
  Create = 'create',
  Netwrok = 'network',
  NetwrokGroup = 'networkGroup',
  Dealers = 'dealers',
  DealerGroup = 'dealerGroup',
  pymk = 'pymk',
  RequestReceived = 'requestReceived',
  RequestSent = 'requestSent',
  UnitsMetrix = 'unitsMetrix',
  Language = 'language',
  Activity = 'activity',
  PublishVersion = 'publishVersion',
  Division = 'division',
  DivisionCategory = 'divisionCategory',
  Tags = 'tags',
  Setting = 'setting',
  Operators = 'operators',
  RuleField = 'ruleField',
  Member = 'member',
  Network = 'network',
  Cluster = 'cluster',
  operators = 'operators',
  NetworkConnectivity = 'networkConnectivity',
  Domains = 'Domains',
  CompanyDomains = 'companyDomains',
  ProfileFields = 'profileFields',
  RuleClusters = 'ruleClusters',
  User = 'user',
  UserDetails = 'user-details',
  AllUser = 'all-user',
  Details = 'details',
  Permissions = 'permissions',
  Notifications = 'permissions',
  Roles = 'roles',
  PermissionRoles = 'PermissionRoles',
  Inventory = 'inventory',
  Discount = 'discount',
  Countries = 'countries',
  States = 'states',
  Cities = 'cities',
  Currencies = 'currencies',
  CreateJob = 'createJob',
  RevertJob = 'revertJob',
  ApproveJob = 'approveJob',
  RejectJob = 'rejectJob',
  TaskDetail = 'taskDetail',
  SendReminder = 'sendReminder',
  JobOrders = 'jobOrders',
  AllReports = 'AllReports',
  CancelTask = 'CancelTask',
  SendApprovalEmail = 'SendApprovalEmail',
  Password = 'password',
  Discrepancy = 'discrepancy',
  CreateBy = 'createBy',
  GetGenerateReport = 'GetGenerateReport',
  GenerateDiscrepancyReport = 'GenerateDiscrepancyReport',
  FieldStatus = 'DiscrepancyFieldStatus',
  GetDiscrepancyReportDetail = 'DiscrepancyReportDetail',
  GetDiscrepancySeverity = 'GetDiscrepancySeverity',
  GetDiscrepancyStatus = 'GetDiscrepancyStatus',
  GetDiscrepancyReportFields = 'GetDiscrepancyReportFields',
  DeleteDiscrepancyFields = 'DeleteDiscrepancyFields',
  AllTemplates = 'AllTemplates',
  TemplateStatus = 'TemplateStatus',
  DeleteTemplate = 'DeleteTemplate',
  UpdateTemplateDetails = 'UpdateTemplateDetails',
  DuplicateTemplate = 'DuplicateTemplate',
  GetTemplateLogs = 'GetTemplateLogs',
  GetTemplatePreview = 'GetTemplatePreview',
  GuestMode = 'GuestMode',
  GetCoachChecklist = 'GetCoachChecklist',
  SubmitReport = 'submitReport',
  DraftReport = 'draftReport',
  GetDraftCheckList = 'GetDraftChecklist',
  EndSession = 'EndSession',
}
export const ListStatus: EnumType = {
  active: '1',
  inactive: '2',
}
export const SeoDescType: EnumType = {
  html: 'HTML',
  plain: 'PLAIN',
}

export const SortBy: EnumType = {
  all: '0',
  recent: '1',
  favourite: '2',
  active: '10',
  inActive: '11',
  sold: '12',
  inAuction: '13',
  draft: '14',
}

export const ListMarketplaceStatus: EnumType = {
  sold: '5',
  purchased: '12',
  auction: '0',
  active: '1',
  inactive: '2',
}

export const SortOrder: EnumType = {
  recently: '0',
  ascending: '1',
  descending: '2',
}
export enum dashboard {
  analytics = 'Analytics',
  userActivity = 'Users Activity',
  recentListings = 'Recent Listings',
  bidLimit = 'Bid Limit',
  financeCalculator = 'Finance Calculator',
  auctionCategory = 'Auction Categories',
  quickInvitation = 'Quick Invitations',
  qrCode = 'Invitation QR code',
  manufacturer = 'Manufacturer',
  businessNetwork = 'My Business Network',
  connections = 'My Connections',
  dealer = 'Dealers',
  dealerGroup = 'Dealer Groups',
}

export enum FavouriteListingAction {
  add = '1',
  remove = '2',
}

export const ListingType: EnumType = {
  sale: '1',
  rent: '2',
  auction: '0',
  favourite: '3',
}

export enum NetworkState {
  networkDetail = 'networkDetails',
  createGroup = 'createGroup',
  createGroupCompleted = 'createGroupCompleted',
  networkMessage = 'networkMessages',
  networkDelete = 'networkDelete',
  userConnect = 'userConnect',
}

export enum InvitationMethodState {
  invitation = 'invitation',
  connect = 'connect',
  tag = 'tag',
}

export enum DealerState {
  dealerDetail = 'dealerDetails',
  createGroup = 'createGroup',
  createGroupCompleted = 'createGroupCompleted',
  dealerMessage = 'dealerMessages',
  dealerDelete = 'dealerDelete',
  CategoriesList = 'categoriesList',
  SubCategoriesList = 'subCategoriesList',
  SectionsList = 'sectionsList',
  SectionFieldsList = 'sectionFieldsList',
}

export const Levels = {
  category: 0,
  subCategory: 1,
  section: 2,
  field: 3,
  type: 4,
  ruleField: 5,
} as const

export const ImageVariables: { [key: string | number]: string } = {
  [Levels.category]: 'category',
  [Levels.subCategory]: 'sub-category',
  [Levels.section]: 'section',
  [Levels.field]: 'field',
  [Levels.type]: 'types',
  // 'mainLogo': 'mainLogo',
}

export const EntityActions = {
  edit: 0,
  toggle: 1,
  delete: 2,
  add: 3,
  save: 4,
  cancel: 5,
}

export const VersionType = {
  INSPEQ: 'Inspeq',
  CONFIGURATOR: 'Marketplace',
}

export enum ContrastLevel {
  veryPoor = 1,
  poor = 2,
  good = 3,
  veryGood = 4,
  super = 5,
}

export enum UserStatusType {
  PENDING_SIGNUP = 'PENDING_SIGNUP',
  PROFILE_PENDING = 'PROFILE_PENDING',
  CONFIRMED = 'CONFIRMED',
  VERIFICATION_PENDING = 'VERIFICATION_PENDING',
}

export enum UserRoleType {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum fields {
  NUMERIC = 'NUMERIC',
  RATING = 'RATING',
  RATING_WITH_COMMENT = 'RATING_WITH_COMMENT',
  RADIO = 'RADIO',
  RADIO_WITH_COMMENTS = 'RADIO_WITH_COMMENTS',
  CHECKBOX = 'CHECKBOX',
  LOCATION = 'LOCATION',
  DAY_CALENDAR = 'DAY_CALENDAR',
  CALENDAR = 'CALENDAR',
  FILE = 'FILE',
  DROPDOWN_SINGLE_SELECTION = 'DROPDOWN_SINGLE_SELECTION',
  DROPDOWN_MULTIPLE_SELECTION = 'DROPDOWN_MULTIPLE_SELECTION',
  TEXT = 'TEXT',
  COMMENTS = 'COMMENTS',
}

export enum taskTypesEnum {
  GENERAL_INSPECTION = 'GENERAL_INSPECTION',
  RENTAL_CHECK_IN = 'RENTAL_CHECK_IN',
  RENTAL_CHECK_OUT = 'RENTAL_CHECK_OUT',
}

export enum taskStatusEnum {
  PENDING = 'PENDING',
  OWNER_APPROVAL = 'OWNER_APPROVAL',
  CUSTOMER_APPROVAL = 'CUSTOMER_APPROVAL',
  REVERT = 'REVERT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  REASSIGNED = 'REASSIGNED',
}

export enum discrepancyStatusEnum {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  DONE = 'DONE',
  RESOLVED = 'Resolved',
  PENDING_REVIEW = 'Pending Review',
  PARTIALLY_RESOLVED = 'Partially Resolved',
  INPROGRESS = 'In Progress',
}

export enum discrepancySeverityEnum {
  MINOR = 'MINOR',
  MODERATE = 'MODERATE',
  MAJOR = 'MAJOR',
  CRITICAL = 'CRITICAL',
}
export enum discrepancyActionsEnum {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  ATTENTION_REQUIRED = 'ATTENTION_REQUIRED',
  REPLACEMENT_REQUIRED = 'REPLACEMENT_REQUIRED',
  MAINTENANCE_REQUIRED = 'MAINTENANCE_REQUIRED',
}
export enum reportTypeEnum {
  GENERAL_INSPECTION = 'General Inspection',
  RENTAL_CHECK_IN = 'Rental Check In',
  RENTAL_CHECK_OUT = 'Rental Check Out',
}

export enum templateStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DRAFTED = 'DRAFTED',
  ARCHIVED = 'ARCHIVED',
}

export enum DIVISION {
  CREATE = 'create_division',
  UPDATE = 'update_division',
  VIEW = 'get_division',
  DELETE = 'delete_division',
}

export enum CATEGORY {
  CREATE = 'create_category',
  UPDATE = 'update_category',
  VIEW = 'get_category',
  DELETE = 'delete_category',
}
export enum SUB_CATEGORY {
  CREATE = 'create_sub_category',
  UPDATE = 'update_sub_category',
  VIEW = 'get_sub_category',
  DELETE = 'delete_sub_category',
}
export enum SECTION {
  CREATE = 'create_section',
  UPDATE = 'update_section',
  VIEW = 'get_section',
  DELETE = 'delete_section',
}
export enum FIELD {
  CREATE = 'create_fields',
  UPDATE = 'update_fields',
  VIEW = 'get_fields',
  DELETE = 'delete_fields',
}
export enum CLUSTER {
  CREATE = 'create_cluster',
  UPDATE = 'update_cluster',
  VIEW = 'get_cluster',
  DELETE = 'delete_cluster',
}
export enum NETWORK {
  CREATE = 'create_network',
  UPDATE = 'update_network',
  VIEW = 'get_network',
  DELETE = 'delete_network',
}
export enum ROLE {
  CREATE = 'create_roles',
  UPDATE = 'update_roles',
  VIEW = 'get_roles',
  DELETE = 'delete_roles',
  ASSIGN = 'assign_roles',
}
export enum INVENTORY {
  CREATE = 'create_inventory',
  UPDATE = 'update_inventory',
  VIEW = 'get_inventory',
  DELETE = 'delete_inventory',
}
export enum INSPECTION_REPORTS {
  CREATE = 'create_reports',
  UPDATE = 'update_reports',
  VIEW = 'get_reports',
  DELETE = 'delete_reports',
}
export enum VERSIONS {
  PUBLISH = 'publish_version',
  VIEW = 'get_version',
  ROLLBACK = 'rollback_version',
}
export enum USERS_PROFILE {
  CREATE_PROFILE_FIELD = 'create_profile_field',
  UPDATE_PROFILE_FIELD = 'update_profile_field',
  DELETE_PROFILE_FIELD = 'delete_profile_field',
  ADD_USER = 'add_user',
  DELETE_USER = 'delete_user',
  VIEW_USERS = 'get_users',
  SEND_EMAIL = 'send_email',
  UPDATE_STATUS = 'update_status',
  VIEW_PROFILE_FIELD = 'get_profile_field',
}
export enum TEMPLATES {
  CREATE = 'create_template',
  UPDATE = 'update_template',
  VIEW = 'get_template',
  DELETE = 'delete_template',
  DUPLICATE = 'duplicate_template',
  GET_ACTIVITY = 'get_activity',
}

//NEW ENUMS OF ROLES
export enum CONFIGURATOR {
  VIEW = 'configurator_read_only',
  UPDATE = 'configurator_edit',
}

export enum JOB_ORDERS {
  CREATE_DISCREPANCY = 'create_discrepancy_report',
  UPDATE = 'manage_job_orders',
  VIEW = 'job_order_read_only',
}

export enum USER_MANAGEMENT {
  UPDATE = 'user_management_edit',
  VIEW = 'user_management_read_only',
  UPDATE_ROLES = 'user_management_roles_edit',
}

export enum CLUSTER_NETWORK_MANAGEMENT {
  UPDATE = 'network_management_edit',
  VIEW = 'cluster_network_management_read_only',
  UPDATE_CLUSTER = 'cluster_management_edit',
}

export enum INVENTORY_MANAGEMENT {
  UPDATE = 'inventory_management_edit',
  VIEW = 'inventory_management_read_only',
}

export enum TENANTS {
  UPDATE = 'tenants_edit',
  VIEW = 'tenants_read_only',
}
